import { Col, Row, Typography } from 'antd';
import * as FaIcons from 'react-icons/fa';
import CelularMockup from '../../../../../../components/CelularMockup';
import ImagemLogo from '../../../../../../assets/logo.png';
import ImagemLogoDark from '../../../../../../assets/logo_dark.png';
import { urlIconeModuloImagem } from '../../../../../../services/request/urls';
import { IAlteracoes } from '../../ListVersaoApp/useListVersaoApp';
import { useSelector } from 'react-redux';
import { stateGlobal } from '../../../../../../interfaces/Global';

const PreVisualizacaoAlteracoes = ({ alteracoes, versao }: { alteracoes: IAlteracoes[], versao: string }) => {
    const { Text } = Typography;
    const propsState = useSelector((state: stateGlobal) => state.global);

    return (
        <CelularMockup>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '30px', flexDirection: 'column' }} >
                    <img width="180px" src={propsState.theme === 'dark' ? ImagemLogoDark : ImagemLogo} alt="Logo" />

                    <Text strong style={{ marginTop: '20px', fontSize: '26px' }}>O que há de novo?</Text>
                    {versao && <Text type='secondary' strong style={{ fontSize: '16px' }}>v{versao}</Text>}

                    <div style={{ padding: '0 12px', marginBottom: 10, overflowY: 'auto', overflowX: 'hidden', maxHeight: '450px' }}>
                        {alteracoes.map((item, index) => {
                            const IconComponent = item.fileIcone && FaIcons[item.fileIcone as keyof typeof FaIcons];
                            return (
                                <Row
                                    key={index}
                                    align="middle"
                                    justify="space-between"
                                    style={{ marginTop: 20 }}
                                    gutter={16}
                                >
                                    <Col span={6} style={{ textAlign: 'center', }}>
                                        {item.fileImage && <img width={40} src={urlIconeModuloImagem + item.fileImage} />}
                                        {IconComponent && <IconComponent  size={40} color="#2d9cdb" />}
                                    </Col>

                                    <Col span={18} style={{ padding: 4 }}>
                                        <h4 style={{ margin: 0, fontSize: '14px', fontWeight: 'bold', lineHeight: '1.3', width: 250 }} >{item.titulo}</h4>
                                        <p style={{
                                            margin: 0,
                                            fontSize: '12px',
                                            lineHeight: '1.3',
                                            color: '#999'
                                        }}>{item.descricao}</p>
                                    </Col>
                                </Row>
                            );
                        })}
                    </div>
                    <button style={{
                        width: 300,
                        position: 'absolute',
                        bottom: '40px',
                        height: '38px',
                        background: '#2d9cdb',
                        border: 'none',
                        borderRadius: '5px',
                        color: '#fff',
                    }}>Ok</button>
                </div>
            </div>
        </CelularMockup>
    );
};


export default PreVisualizacaoAlteracoes;
